/**
 * Normalise une chaîne en retirant les accents et en mettant en minuscules
 */
export const normalizeString = (str: string): string => {
  return str
    .normalize('NFD') // Décompose les caractères accentués
    .replace(/[\u0300-\u036f]/g, '') // Retire les accents
    .toLowerCase();
};

/**
 * Compare deux chaînes sans tenir compte de la casse et des accents
 */
export const compareStringsNormalized = (str1: string, str2: string): boolean => {
  return normalizeString(str1) === normalizeString(str2);
};

/**
 * Vérifie si une chaîne contient une autre, sans casse ni accents
 */
export const containsNormalized = (haystack: string, needle: string): boolean => {
  return normalizeString(haystack).includes(normalizeString(needle));
};

